import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import LandActionsApi from '@/services/apiServiceModules/landActionsApi.js'
const landActionsApi = new LandActionsApi()

export default class LandActionsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.LAND_ACTIONS, landActionsApi, {
			useCache: true,
		})
	}
}
